@if (error()) {
  <p class="cl-p-regular cl-color-brick">{{ error() }}</p>
}

<div class="cl-table-scroll">
  <table class="cl-table-data">
    <thead>
      <tr>
        <th class="cl-table-head">Name</th>
        <th class="cl-table-head cl-th-currency">Size</th>
        <th class="cl-table-head">Modified</th>
        @if (actionTemplate) {
          <th class="cl-table-head cl-th-links">{{ actionHeader() }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        <tr class="cl-tr-no-data"><td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td></tr>
      } @else {
        @for (row of rows(); track row.entry.folderId + row.entry.path) {
          <tr [class.folder-row]="row.entry.isDirectory">
            <td [style.padding-left.rem]="row.depth * 1.25">
              @if (row.entry.isDirectory) {
                <a class="cl-a-link" (click)="toggle(row)">
                  <i class="fas"
                     [class.fa-chevron-right]="!row.expanded && !row.loading"
                     [class.fa-chevron-down]="row.expanded && !row.loading"
                     [class.fa-spinner]="row.loading"
                     [class.fa-spin]="row.loading"></i>
                  {{ row.entry.name }}</a>
                @if (row.error) {
                  <small class="cl-color-brick"> — {{ row.error }}</small>
                } @else if (row.empty) {
                  <small class="cl-faded"> — empty</small>
                }
              } @else {
                {{ row.entry.name }}
              }
            </td>
            <td class="cl-td-currency">{{ row.entry.isDirectory ? '—' : (row.entry.size | fileSize) }}</td>
            <td class="cl-td-time"><app-date [value]="row.entry.modifiedAt" empty="—" /></td>
            @if (actionTemplate) {
              <td class="cl-td-links" width="1%">
                @if (!row.entry.isDirectory) {
                  <ng-container
                    [ngTemplateOutlet]="actionTemplate"
                    [ngTemplateOutletContext]="{$implicit: row.entry}"></ng-container>
                }
              </td>
            }
          </tr>
        }
        @if (noSession() && rows().length === 0) {
          <!-- null (not empty) means the API could not list: no session -->
          <tr class="cl-tr-no-data"><td colspan="100">Log in to this portal to browse its files.</td></tr>
        } @else if (rows().length === 0) {
          <tr class="cl-tr-no-data"><td colspan="100">This portal exposes no files.</td></tr>
        }
      }
    </tbody>
  </table>
</div>
